export default __webpack_public_path__ + "static/media/Element4.f9ddfd81.png";